import { render } from "./create_survey.html?vue&type=template&id=aab3b636&external"
import script from "./create_survey.js?vue&type=script&lang=js&external"
export * from "./create_survey.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__